<template>
  <div class="wizard-body small-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.OMNE_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.OMNE_CHANNEL.DESC')"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div class="medium-8 columns">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.OMNE_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.OMNE_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
              $t('INBOX_MGMT.ADD.OMNE_CHANNEL.CHANNEL_NAME.ERROR')
            }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.username.$error }">
          {{ $t('INBOX_MGMT.ADD.OMNE_CHANNEL.USERNAME.LABEL') }}
          <input
            v-model.trim="username"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.OMNE_CHANNEL.USERNAME.PLACEHOLDER')
            "
            @blur="getOmneData"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.OMNE_CHANNEL.USERNAME.SUBTITLE') }}
        </p>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.password.$error }">
          {{ $t('INBOX_MGMT.ADD.OMNE_CHANNEL.PASSWORD.LABEL') }}
          <input
            v-model.trim="password"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.OMNE_CHANNEL.PASSWORD.PLACEHOLDER')
            "
            @blur="getOmneData"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.OMNE_CHANNEL.PASSWORD.SUBTITLE') }}
        </p>
      </div>

      <div class="divider">&nbsp;</div>

      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.OMNE_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators';
import PageHeader from '../../SettingsSubPageHeader';
import alertMixin from 'shared/mixins/alertMixin';
import getUuid from 'widget/helpers/uuid';
import router from "../../../../index";
import { mapGetters } from 'vuex';

export default {
  name: 'Omne',
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      username: '',
      password: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    username: { required },
    password: { required },
  },
  methods: {
    getOmneData() {
      //
    },
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const omneChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'omne',
              identifier: getUuid(),
              username: this.username,
              password: this.password,
              custom_config: {}
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: omneChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.OMNE_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  .divider {
    background: #b8b9bb;
    height: 1px;
    margin: 1.5rem 0;
    flex: 0 0 100%;
  }
}
</style>
